/**
 * Query key factory for acc-dashboard feature.
 * Follows TanStack Query best practices for key organisation.
 */
export const accDashboardKeys = {
  all: ['acc-dashboard'] as const,
  dashboard: () => [...accDashboardKeys.all, 'data'] as const,
};
